/**
 * 应用角标。
 *
 * ⚠️ API 挂在 `navigator` 上——**Service Worker 全局里也是 `navigator.setAppBadge(...)`**，
 * 不是 `registration.setAppBadge`。写错不会报错，只是角标永远不出现（踩过）。
 *
 * ⚠️ 角标和通知是两套东西：`clearAppBadge()` 一根手指都碰不到通知中心里那条横幅。
 * 想要两者同步，用 @pwaship/core/unread 的 UnreadController，别单独调这里。
 */
import { fail, failFrom, ok } from './result.js';
function badgeNav() {
    return typeof navigator === 'undefined' ? undefined : navigator;
}
export function badgeSupported() {
    return typeof badgeNav()?.setAppBadge === 'function';
}
/**
 * 设置角标。
 *
 * 传 0 会走 clearAppBadge —— 规范里 setAppBadge(0) 是"清除"，但部分实现会显示一个空圆点，
 * 统一走 clear 更稳。
 */
export async function setBadge(count) {
    const nav = badgeNav();
    if (typeof nav?.setAppBadge !== 'function')
        return fail('unsupported');
    const n = Number.isFinite(count) ? Math.max(0, Math.trunc(count)) : 0;
    try {
        if (n === 0) {
            await nav.clearAppBadge?.();
        }
        else {
            await nav.setAppBadge(n);
        }
        return ok(n);
    }
    catch (e) {
        // iOS 上没有通知权限时这里会拒绝。不是 bug，是平台行为——报出来让调用方能提示用户。
        return failFrom('permission-denied', e);
    }
}
export async function clearBadge() {
    return setBadge(0);
}
//# sourceMappingURL=badge.js.map